import { useState, useEffect, useContext } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { TenantContext } from '../../../../contexts/TenantContext';
import TaskService from '../../../../services/task_service';
import EmployeeService from '../../../../services/employee_service';
import MemberService from '../../../../services/member_service';
import { taskSchema, taskDefaults } from '../../../../models/task';

export const useCreateTask = (onSuccessCallback, onClose) => {
    const { idTenant, user } = useContext(TenantContext);


    const [members, setMembers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [loadingResources, setLoadingResources] = useState(false);

    // Formik configuration
    const formik = useFormik({
        initialValues: taskDefaults,
        validationSchema: taskSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            if (!idTenant) {
                toast.error("Erro ao identificar o tenant ativo.");
                return;
            }
            try {
                // If the value strings refer to IDs, we need to find the full objects so the converter can denormalize them
                const selectedMemberObj = members.find(m => m.id === values.selectedMember) || null;
                const selectedEmployeesObjs = employees.filter(e => (values.selectedEmployees || []).includes(e.id));

                const preparedValues = {
                    ...values,
                    selectedMember: selectedMemberObj,
                    selectedEmployees: selectedEmployeesObjs
                };

                const newTask = await TaskService.createTask(idTenant, user, preparedValues);
                toast.success("Tarefa criada com sucesso!");
                resetForm();
                if (onSuccessCallback) onSuccessCallback(newTask);
                if (onClose) onClose();
            } catch (error) {
                console.error("Erro no formulário de tarefa:", error);
                toast.error("Erro ao criar tarefa.");
            } finally {
                setSubmitting(false);
            }
        }
    });

    // Load form select options
    useEffect(() => {
        let isMounted = true;

        const loadResources = async () => {
            if (!idTenant) return;
            setLoadingResources(true);
            try {
                // We run in parallel to load everything faster
                const [membersList, employeesList] = await Promise.all([
                    MemberService.getMembers(idTenant),
                    EmployeeService.getAllByTenant(idTenant)
                ]);

                if (isMounted) {
                    setMembers(membersList);
                    setEmployees(employeesList);
                }
            } catch (err) {
                console.error("Erro ao carregar recursos do formulário:", err);
                if (isMounted) toast.error("Não foi possível carregar os clientes e funcionários.");
            } finally {
                if (isMounted) setLoadingResources(false);
            }
        };

        if (idTenant) {
            loadResources();
        }

        return () => { isMounted = false; };
    }, [idTenant]);

    return {
        formik,
        members,
        employees,
        loadingResources
    };
};
